import { MatrixPropertyValidator } from 'app/models/questions/property-validator/MatrixPropertyValidator'
import { IImage } from 'app/interfaces/IImage'
import { IImageSelection } from 'app/interfaces/IImageSelection'

export class ImagePropertyValidator extends MatrixPropertyValidator implements IImage {
  imageSelection: IImageSelection

  constructor(question) {
    super(question)

    this.imageSelection = question.imageSelection
  }
}
